export default "__VITE_ASSET__3xueZDhx__"